const validateShowHide3 = require("./validateShowHide3");

module.exports = {
  validateShowHide3,
};
